export default {
  // ========== Encabezado ==========
  didacticSuitcasePlan: "Plan de Maleta Didáctica",
  subjectDescription: "Descripción de Asignatura",

  // ========== Primera Tabla: Información General ==========
  academicUnit: "Unidad Acádemica",
  subjectName: "Nombre Asignatura",
  duocCredits: "Créditos DUOC",
  prerequisites: "Prerequisitos",
  careerName: "Nombre Carrera/s",
  technicalProfessional: "Técnica/Profesional",
  code: "Sigla",
  directedTeachingHoursSemester: "Horas Docencia Dirigida Semestre (Pedagógicas)",
  teacherCount: "N° Docentes",
  notApplicable: "No Aplica",
  studyPlans: "Planes de Estudio",
  directedTeachingHoursBreakdown: "Hrs. Docencia Dirigida Presencial / Docencia Dirigida No Presencial",
  assistantCount: "N° Ayudantes",
  formationLine: "Línea Formativa",
  transferableAcademicCredits: "Créditos Académicos Transferibles (SCT)",
  assistantshipHours: "N° Horas Ayudantías",
  subjectFormat: "Formato Asignatura (Presencial, FOL, DUAL)",
  programmingWeeks: "N° de Semanas de Programación",
  autonomousWorkHours: "Horas de Trabajo Autónomo",
  publishDate: "Fecha de Publicación",

  // ========== Segunda Tabla: Descripción ==========
  methodologicalStrategies: "Estrategias metodológicas",
  inPersonLearningEnvironments: "Ambiente(s) de Aprendizaje Docencia Dirigida Presencial",
  nonInPersonLearningEnvironments: "Ambiente(s) de Aprendizaje Docencia Dirigida No Presencial",
  transversalFinalEvaluation: "Evaluacion Final Transversal (Situación evaluativa y descripción)",

  // ========== Tercera Tabla: Mapa Formativo ==========
  trainingMap: "Mapa Formativo",
  instructionalDevelopmentPlan: "Desarrollo Instruccional Plan Maleta Didáctica",
  learningResults: "Resultados de Aprendizaje",
  achievementIndicators: "Indicadores de Logro",
  noInformation: "No hay información",
  noLearningResults: "No hay Resultados de Aprendizaje",
  noAchievementIndicators: "No hay Indicadores de Logro",
}
